import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { oidcConfig } from 'utils/keycloak.util'
import { User } from 'oidc-client-ts'

export function getUser() {
  const oidcStorage = localStorage.getItem(
    `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`,
  )
  if (!oidcStorage) {
    return null
  }

  return User.fromStorageString(oidcStorage)
}

const axiosClient: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/v1`,
})

axiosClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => Promise.reject(error),
)

export default axiosClient
